'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommunicationSwapCalls = function CommunicationSwapCalls(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M18 4l-4 4h3v7c0 1.1-.9 2-2 2s-2-.9-2-2V8c0-2.21-1.79-4-4-4S5 5.79 5 8v7H2l4 4 4-4H7V8c0-1.1.9-2 2-2s2 .9 2 2v7c0 2.21 1.79 4 4 4s4-1.79 4-4V8h3l-4-4z' })
  );
};
CommunicationSwapCalls = (0, _pure2.default)(CommunicationSwapCalls);
CommunicationSwapCalls.displayName = 'CommunicationSwapCalls';
CommunicationSwapCalls.muiName = 'SvgIcon';

exports.default = CommunicationSwapCalls;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/svg-icons/communication/swap-calls.js
 ** module id = 1767
 ** module chunks = 0
 **/